import $ from 'jquery';

import { $Elements, Events, getMapLocale, MapMarkers } from './constants';

let maps = [];

$Elements.document.on(Events.page.enter, async () => {

	// ---------- Simple Map ----------

	const $maps = $('.simple-map');

	if(!$maps.length || typeof tc_maps === 'undefined') {
		return;
	}

	// Module ES servi depuis assets/vendor, chargé uniquement sur les pages avec carte
	const { default: StoreLocator } = await import(/* webpackIgnore: true */ tc_maps.module);

	$maps.each(function() {

		let marker = this.dataset.marker;
		marker = (typeof marker === 'string') ? JSON.parse(marker) : marker;

		maps.push(new StoreLocator({
			stores: marker,
			selectors: {
				map: this.attributes.id.value,
			},
			map: {
				workerUrl: tc_maps.worker,
				options: {
					maxZoom: 15,
					locale: getMapLocale(),
				},
				markers: MapMarkers,
			}
		}));
	});

});

$Elements.document.on(Events.page.leave, () => {

	maps.forEach(map => {
		try {
			map.destroy();
		}
		catch(e) {}
	});

	maps = [];
});
